module.exports = __webpack_public_path__ + "img/maininventory.94defed3.png";